// This file contains simplified WHO Weight-for-Age Z-Score data (LMS parameters) for boys 0-24 months.
// L (Box-Cox power), M (median), S (coefficient of variation).
// In a real-world app, you would need complete tables for both genders and different metrics (height, etc.).

export const zScoreWeightForAgeBoys = [
    // age (months), L, M, S
    { age: 0.5, L: -0.1605, M: 4.4069, S: 0.1403 },
    { age: 1.5, L: -0.0722, M: 5.5891, S: 0.1365 },
    { age: 2.5, L: -0.0122, M: 6.5413, S: 0.1334 },
    { age: 3.5, L: 0.0345, M: 7.3032, S: 0.1311 },
    { age: 4.5, L: 0.0715, M: 7.9259, S: 0.1294 },
    { age: 5.5, L: 0.1011, M: 8.4483, S: 0.1281 },
    { age: 6.5, L: 0.1249, M: 8.8963, S: 0.1271 },
    { age: 7.5, L: 0.1441, M: 9.2875, S: 0.1263 },
    { age: 8.5, L: 0.1596, M: 9.6338, S: 0.1257 },
    { age: 9.5, L: 0.1722, M: 9.9438, S: 0.1252 },
    { age: 10.5, L: 0.1824, M: 10.2238, S: 0.1248 },
    { age: 11.5, L: 0.1906, M: 10.4788, S: 0.1245 },
    { age: 12.5, L: 0.1973, M: 10.7129, S: 0.1243 },
    { age: 13.5, L: 0.2025, M: 10.9292, S: 0.1241 },
    { age: 15.5, L: 0.209, M: 11.321, S: 0.1241 },
    { age: 17.5, L: 0.211, M: 11.675, S: 0.1245 },
    { age: 19.5, L: 0.209, M: 12.007, S: 0.1251 },
    { age: 21.5, L: 0.205, M: 12.325, S: 0.1258 },
    { age: 23.5, L: 0.198, M: 12.629, S: 0.1266 },
    // Extended data for ages 24-60 months (2-5 years)
    { age: 25.5, L: 0.190, M: 12.920, S: 0.1275 },
    { age: 27.5, L: 0.182, M: 13.200, S: 0.1284 },
    { age: 29.5, L: 0.174, M: 13.470, S: 0.1293 },
    { age: 31.5, L: 0.166, M: 13.730, S: 0.1302 },
    { age: 33.5, L: 0.158, M: 13.980, S: 0.1311 },
    { age: 35.5, L: 0.150, M: 14.220, S: 0.1320 },
    { age: 37.5, L: 0.142, M: 14.450, S: 0.1329 },
    { age: 39.5, L: 0.134, M: 14.670, S: 0.1338 },
    { age: 41.5, L: 0.126, M: 14.880, S: 0.1347 },
    { age: 43.5, L: 0.118, M: 15.080, S: 0.1356 },
    { age: 45.5, L: 0.110, M: 15.270, S: 0.1365 },
    { age: 47.5, L: 0.102, M: 15.450, S: 0.1374 },
    { age: 49.5, L: 0.094, M: 15.620, S: 0.1383 },
    { age: 51.5, L: 0.086, M: 15.780, S: 0.1392 },
    { age: 53.5, L: 0.078, M: 15.930, S: 0.1401 },
    { age: 55.5, L: 0.070, M: 16.070, S: 0.1410 },
    { age: 57.5, L: 0.062, M: 16.200, S: 0.1419 },
    { age: 59.5, L: 0.054, M: 16.320, S: 0.1428 },
];

// Weight-for-age data for girls (extended)
export const zScoreWeightForAgeGirls = [
    { age: 0.5, L: -0.1715, M: 4.2000, S: 0.1395 },
    { age: 1.5, L: -0.0826, M: 5.1800, S: 0.1351 },
    { age: 2.5, L: -0.0222, M: 6.0300, S: 0.1319 },
    { age: 3.5, L: 0.0249, M: 6.7300, S: 0.1295 },
    { age: 4.5, L: 0.0608, M: 7.3000, S: 0.1278 },
    { age: 5.5, L: 0.0882, M: 7.7700, S: 0.1264 },
    { age: 6.5, L: 0.1094, M: 8.1700, S: 0.1254 },
    { age: 7.5, L: 0.1263, M: 8.5100, S: 0.1246 },
    { age: 8.5, L: 0.1398, M: 8.8100, S: 0.1239 },
    { age: 9.5, L: 0.1507, M: 9.0800, S: 0.1234 },
    { age: 10.5, L: 0.1595, M: 9.3200, S: 0.1230 },
    { age: 11.5, L: 0.1667, M: 9.5400, S: 0.1226 },
    { age: 12.5, L: 0.1724, M: 9.7400, S: 0.1223 },
    { age: 13.5, L: 0.1769, M: 9.9300, S: 0.1221 },
    { age: 15.5, L: 0.1836, M: 10.280, S: 0.1218 },
    { age: 17.5, L: 0.1875, M: 10.600, S: 0.1218 },
    { age: 19.5, L: 0.1890, M: 10.900, S: 0.1220 },
    { age: 21.5, L: 0.1884, M: 11.200, S: 0.1223 },
    { age: 23.5, L: 0.1863, M: 11.480, S: 0.1227 },
    // Extended data for ages 24-60 months (2-5 years)
    { age: 25.5, L: 0.1830, M: 11.750, S: 0.1232 },
    { age: 27.5, L: 0.1790, M: 12.010, S: 0.1237 },
    { age: 29.5, L: 0.1745, M: 12.260, S: 0.1243 },
    { age: 31.5, L: 0.1695, M: 12.500, S: 0.1249 },
    { age: 33.5, L: 0.1640, M: 12.730, S: 0.1255 },
    { age: 35.5, L: 0.1580, M: 12.950, S: 0.1262 },
    { age: 37.5, L: 0.1515, M: 13.160, S: 0.1269 },
    { age: 39.5, L: 0.1445, M: 13.360, S: 0.1276 },
    { age: 41.5, L: 0.1370, M: 13.550, S: 0.1284 },
    { age: 43.5, L: 0.1290, M: 13.730, S: 0.1292 },
    { age: 45.5, L: 0.1205, M: 13.900, S: 0.1300 },
    { age: 47.5, L: 0.1115, M: 14.060, S: 0.1308 },
    { age: 49.5, L: 0.1020, M: 14.210, S: 0.1317 },
    { age: 51.5, L: 0.0920, M: 14.350, S: 0.1326 },
    { age: 53.5, L: 0.0815, M: 14.480, S: 0.1335 },
    { age: 55.5, L: 0.0705, M: 14.600, S: 0.1344 },
    { age: 57.5, L: 0.0590, M: 14.710, S: 0.1354 },
    { age: 59.5, L: 0.0470, M: 14.810, S: 0.1364 },
];

// Formula to calculate Z-Score:
// Z = ( (value / M)**L - 1 ) / (L * S)
// Formula to calculate value for a given Z-score:
// Value = M * (1 + L * S * Z)**(1/L)
